var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('VDropdown',{attrs:{"triggers":['hover'],"popper-triggers":['hover'],"delay":{ show: 200, hide: 100 },"distance":0,"popper-class":"nav-dropdown","placement":"bottom-start"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var shown = ref.shown;
return [_vm._t("default",null,null,{ shown: shown })]}},{key:"popper",fn:function(){return [_vm._t("popper")]},proxy:true}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }